<template>
    <section id="project_content">

        <div class="container">

            <!-- data-bs-ride="carousel" class="carousel-fade" -->
            <div id="carouselProjectComponents" class="carousel slide">

                <div class="carousel-inner">

                    <!-- data-bs-interval="10000" -->
                    <div class="carousel-item active">
                        <!-- Start ProjectOne Component -->
                        <ProjectOne />
                        <!-- End ProjectOne Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectTwo Component -->
                        <ProjectTwo />
                        <!-- End ProjectTwo Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectThree Component -->
                        <ProjectThree />
                        <!-- End ProjectThree Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectFour Component -->
                        <ProjectFour />
                        <!-- End ProjectFour Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectFive Component -->
                        <ProjectFive />
                        <!-- End ProjectFive Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectSix Component -->
                        <ProjectSix />
                        <!-- End ProjectSix Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectSeven Component -->
                        <ProjectSeven />
                        <!-- End ProjectSeven Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectEight Component -->
                        <ProjectEight />
                        <!-- End ProjectEight Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectNine Component -->
                        <ProjectNine />
                        <!-- End ProjectNine Component -->
                    </div>

                    <div class="carousel-item">
                        <!-- Start ProjectTen Component -->
                        <ProjectTen />
                        <!-- End ProjectTen Component -->
                    </div>

                </div>

                <!-- https://www.youtube.com/watch?v=BrCz-FlPGgk -->

                <!-- Carousel controls -->

                <div class="d-flex justify-content-center">

                    <button class="carousel-control-next" type="button" data-bs-target="#carouselProjectComponents"
                        data-bs-slide="next">
                        <font-awesome-icon :icon="['fas', 'fa-arrow-right']" />
                    </button>

                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselProjectComponents"
                        data-bs-slide="prev">
                        <font-awesome-icon :icon="['fas', 'fa-arrow-left']" />
                    </button>

                </div>

            </div>

        </div>

    </section>
</template>

<script>

import ProjectOne from '@/components/project/ProjectOne.vue';
import ProjectTwo from '@/components/project/ProjectTwo.vue';
import ProjectThree from '@/components/project/ProjectThree.vue';
import ProjectFour from '@/components/project/ProjectFour.vue';
import ProjectFive from '@/components/project/ProjectFive.vue';
import ProjectSix from '@/components/project/ProjectSix.vue';
import ProjectSeven from '@/components/project/ProjectSeven.vue';
import ProjectEight from '@/components/project/ProjectEight.vue';
import ProjectNine from '@/components/project/ProjectNine.vue';
import ProjectTen from '@/components/project/ProjectTen.vue';

export default {

    name: 'Project',

    components: {
        ProjectOne,
        ProjectTwo,
        ProjectThree,
        ProjectFour,
        ProjectFive,
        ProjectSix,
        ProjectSeven,
        ProjectEight,
        ProjectNine,
        ProjectTen,
    },

    /* data() {
        return {
            windowHeight: window.innerHeight,
        }
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            if (this.windowHeight < 895) {
                // document.getElementsByClassName('carousel-item').style.height = "100%";
                // document.getElementsByClassName('carousel-inner').style = "min-height: 83vh;";
                // document.getElementsByClassName('carousel-item').style = "min-height: 83vh;";
                // document.getElementsByClassName('carousel-item').style = "height: auto !important";
                document.getElementsByClassName('carousel-inner').style = "min-height: 83vh;";
                document.getElementsByClassName('carousel-item').style = "height: auto";
            } else{
                document.getElementsByClassName('carousel-item').style = "height: 83vh";
            }
        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        onResize() {
            this.windowHeight = window.innerHeight;
        }
    } */

}
</script>

<style lang="scss" scoped>
#project_content {

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        .carousel {

            .carousel-inner {

                @include breakpoints(x-small) {
                    min-height: 83vh;
                }

                @include breakpoints(small) {
                    min-height: 83vh;
                }

                @include breakpoints(medium) {
                    min-height: 83vh;
                }

                .carousel-item {
                    width: 100%;
                    
                    min-height: 83vh;

                    @include breakpoints(x-small) {
                        height: auto;
                    }

                    @include breakpoints(small) {
                        height: auto;
                    }

                    @include breakpoints(medium) {
                        height: auto;
                    }

                }

            }

            .carousel-control-prev,
            .carousel-control-next {
                position: static;
                padding-top: 15px;
                width: 70px;

            }

            .carousel-control-prev svg,
            .carousel-control-next svg {
                color: $Green;
                font-size: 24px;
            }


        }

    }

}
</style>